// import './index.css'
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getText } from "../../utils/util";
import { DotLoading } from 'antd-mobile'
import { useEffect, useState } from 'react';
import { pledgeList } from '../../api/pledge';
import { getLabel,PledgeListStatus } from '../../utils/dict';
import { AcendexLayout } from '@/components/acendex/components/layout/AcendexLayout';

// 定义列表项类型
interface ListItemType {
    orderNo: string;
    num: number | string;
    createTime: string;
    status: number;
    [key: string]: any;
}

export default function repaymentList() {

    const navigate = useNavigate();
    const { t: translate } = useTranslation();
    const [loading, setLoading] = useState(false)
    const [dataList, setDataList] = useState<ListItemType[]>([])
    
    const getData = () => {
        setLoading(true)
        pledgeList({
            page: 1,
            pageSize: 10,
            uid: localStorage.getItem("uid")
        }).then(res => {
            setDataList(res.data)
        }).finally(()=>{
            setLoading(false)
        })
    }
    
    useEffect(() => {
        getData()
    }, [])
    
    return (
        <div className='w-full min-h-dvh bg-neutral-900'>
        <AcendexLayout
            theme="light"
            mobileTopBarTitle={translate(getText("借幣明細"))}
            pcTopBarTitle={translate(getText("借幣明細"))}
        >
            <div className='container mx-auto px-4 md:px-6 py-4 max-w-4xl'>
                
                {dataList.length > 0 ? dataList.map((item,index)=>(
                    <div 
                        key={index} 
                        onClick={()=>{navigate("/repaymentInfo/"+item.orderNo)}}
                        className="bg-neutral-800 rounded-xl p-4 mb-3 shadow-card flex justify-between items-center cursor-pointer hover:bg-neutral-700 transition-colors duration-200"
                    >
                        <div className="flex flex-col">
                            <div className='text-base md:text-lg font-bold text-neutral-100'>{item.status == 5 && '-'}{item.num} USDT</div>
                            <div className='text-xs md:text-sm text-neutral-400 mt-2'>{item.createTime}</div>
                        </div>
                        <div className='text-primary font-medium'>{translate(getText(getLabel(PledgeListStatus,item.status)))}</div>
                    </div>
                )) : null }
                
                {loading ? (
                <div className='flex justify-center items-center py-6'>
                    <DotLoading color='primary' />
                </div>
                ) : (
                <div className="text-center py-4 text-neutral-400 text-sm">
                    {translate(getText("没有更多数据了"))}
                </div>
                )}
            </div>
            </AcendexLayout>
        </div>
    )
}